import Resource from '@/api/Resource';

export default class extends Resource {
  $name = 'servers';

  $defaults() {
    return {
      id: null,
      ip: '',
      status: '',
      name: '',
      description: '',
      updated_at: null,
      created_at: null,
    };
  }
}
